import { Component } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { NGXLogger } from 'ngx-logger';

import packageInfo from '../../../package.json';

import { getLanguageNameByLanguageCode, getLanguageCodeByLanguageName, languages } from '@dep/frontend/services/countries';
import { TranslationService } from '@dep/frontend/services/translation.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent {
  public readonly version = packageInfo.version;
  public readonly stageSuffix = (environment.stage === 'prod') ? '' : '-' + environment.stage;
  public language = '';
  public allLanguages: { name: string; icon: string }[] = [];

  constructor(
    private logger: NGXLogger,
    private translationService: TranslationService,
    private transloco: TranslocoService,
  ) {
    this.transloco.langChanges$.subscribe(() => {
      this.language = this.translationService.getLanguage();
    });

    this.allLanguages = [];
    for (const langCode in languages) {
      if (languages.hasOwnProperty(langCode)) {
        this.allLanguages.push(languages[langCode]);
      }
    }
  }

  public getLanguageName(languageCode: string): string | undefined {
    return getLanguageNameByLanguageCode(languageCode);
  }

  public changeLanguage(langName: string): void {
    const lang = getLanguageCodeByLanguageName(langName);
    this.logger.debug('Changing language from footer', lang);
    if (lang) {
      this.translationService.changeLanguage(lang);
    }
  }
}
